module.exports = {"es-PY":{"components":{"paginator":{"first":"Comienzo","prev":"Anterior","next":"Siguiente","last":"Final"}}}}